 document.addEventListener('DOMContentLoaded', () => {
    const mobileToggle = document.getElementById('diesel-mobile-nav-toggle-btn');
    const mobileDrawer = document.getElementById('diesel-mobile-drawer-id');
    const drawerClose = document.getElementById('diesel-drawer-close-id');
    const drawerOverlay = document.getElementById('diesel-drawer-overlay-id');
    const accordionHeaders = document.querySelectorAll('.diesel-drawer-group-toggle');

    /**
     * Slide open mobile navigation drawer and lock page scroll
     */
    function openDrawer() {
      if (mobileDrawer && drawerOverlay && mobileToggle) {
        mobileDrawer.classList.add('active');
        drawerOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        mobileToggle.classList.add('active');
      }
    }

    /**
     * Slide close mobile navigation drawer and restore standard scroll actions
     */
    function closeDrawer() {
      if (mobileDrawer && drawerOverlay && mobileToggle) {
        mobileDrawer.classList.remove('active');
        drawerOverlay.classList.remove('active');
        document.body.style.overflow = '';
        mobileToggle.classList.remove('active');
      }
    }

    if (mobileToggle) {
      mobileToggle.addEventListener('click', (e) => {
        e.preventDefault();
        if (mobileDrawer && mobileDrawer.classList.contains('active')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }

    if (drawerClose) {
      drawerClose.addEventListener('click', (e) => {
        e.preventDefault();
        closeDrawer();
      });
    }

    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', (e) => {
        e.preventDefault();
        closeDrawer();
      });
    }

    /**
     * Configure mobile navigation accordion toggles
     */
    accordionHeaders.forEach(header => {
      header.addEventListener('click', (e) => {
        e.preventDefault();
        const parentLi = header.parentElement;
        if (!parentLi) return;

        const subMenu = parentLi.querySelector('.diesel-drawer-nested-nav');
        const icon = header.querySelector('.diesel-drawer-chevron');

        if (subMenu) {
          const isOpen = subMenu.classList.contains('open');

          // Close other active accordion menus
          document.querySelectorAll('.diesel-drawer-nested-nav').forEach(nav => {
            if (nav !== subMenu) {
              nav.classList.remove('open');
              nav.style.maxHeight = null;
            }
          });
          document.querySelectorAll('.diesel-drawer-chevron').forEach(chevron => {
            if (chevron !== icon) {
              chevron.classList.remove('rotate');
            }
          });

          // Toggle chosen sub-navigation list
          if (isOpen) {
            subMenu.classList.remove('open');
            subMenu.style.maxHeight = null;
            if (icon) icon.classList.remove('rotate');
          } else {
            subMenu.classList.add('open');
            subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
            if (icon) icon.classList.add('rotate');
          }
        }
      });
    });
  });